import { PurchaseOffers, SelectedArticle } from "./Catalogue";

export interface LoyaltyEstablishment {
  id: number;
  name: string;
  totalLoyaltyPoints: number;
}

export interface LoyaltyRestaurantsResponse {
  loyalties: LoyaltyEstablishment[];
  isLoyaltyCentralized: boolean;
}

export interface LoyaltyActivity {
  commandNumber: number;
  commandDate: string;
  points: number;
  earned: boolean;
}

export interface PanierDiscount {
  userTotalPoints: number;
  cartRewardTotalPtRequired: number;
  cartRewardDiscountType: number;
  cartRewardThresholdMin: number;
  cartRewardDiscountValue: number;
  errorMessage: string;
}

export interface LoyaltyClient {
  EarnedPoints: number;
  TotalPoints: number;
  EarnedPtFromFirstOrderReward: number;
  EarnedPtFromNbVisitsReward: number;
}

export const loyaltyActivitiesData: LoyaltyActivity[] = [
  {
    commandNumber: 911685,
    commandDate: "2023-03-04",
    points: 53,
    earned: true,
  },
  {
    commandNumber: 245808,
    commandDate: "2023-12-22",
    points: 100,
    earned: true,
  },
  {
    commandNumber: 136664,
    commandDate: "2023-04-28",
    points: 58,
    earned: false,
  },
  {
    commandNumber: 161390,
    commandDate: "2023-04-24",
    points: 61,
    earned: true,
  },
  {
    commandNumber: 341261,
    commandDate: "2023-01-08",
    points: 45,
    earned: true,
  },
  {
    commandNumber: 658947,
    commandDate: "2023-09-13",
    points: 90,
    earned: false,
  },
  {
    commandNumber: 482304,
    commandDate: "2023-07-19",
    points: 77,
    earned: true,
  },
  {
    commandNumber: 738495,
    commandDate: "2023-11-01",
    points: 65,
    earned: false,
  },
  {
    commandNumber: 574839,
    commandDate: "2023-02-18",
    points: 30,
    earned: true,
  },
  {
    commandNumber: 391204,
    commandDate: "2023-05-30",
    points: 50,
    earned: false,
  },
];

export interface ArticleRewardRule {
  id: number;
  name: string;
  imageUrl: string | null;
  rewardTotalPtRequired: number;
  rewardDiscountType: number;
  rewardDiscountValue: number;
}

interface CartRewardRule {
  rewardTotalPtRequired: number;
  rewardDiscountType: number;
  rewardDiscountValue: number;
}

export interface RestaurantArticlesWithDiscount {
  articleRewardRules: ArticleRewardRule[] | null;
  loyaltyClient: {
    id: string;
    loyaltyPoints: number;
  };
  restaurant: {
    name: string,
    imageUrl: string
  }
  cartRewardRule: CartRewardRule | null;
}

export interface CodePromoSuggestion {
  id: number;
  discountType: number;
  discountValue: number;
  cartThreshold: number;
  designation: string;
  message: string;
  isMultiple: boolean;
  beginDate: string;
  endDate: string;
  beginHour: string;
  endHour: string;
  alreadyUsed: boolean;
}

export interface LoyalityGroup {
  id: number;
  isactive: boolean;
  designation: string;
  taux: number;
  seuil: number;
  group_Users: any[];
  iDate: string;
  uDate: string;
  dDate: string | null;
  iUser: string;
  uUser: string;
  dUser: string | null;
  companyId: number;
  isFormule: boolean;
  seuilMax: number;
  partSalariale: number;
  weekend: boolean;
  nbreMaxJour: number;
}

export type OfferGroup = {
  purchaseOffers: PurchaseOffers;
  selectedArticles: SelectedArticle[];
};

export interface GoogleWalletParams {
  userId: string;
  codeFid: string;
  companyId: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface LoyaltyArticle {
  id: string;
  name: string;
  // originalPrice: number;
  // discountedPrice: number;
  discountPercent: number;
  image?: string;
  pointsRequired: number;
  isLocked: boolean;
  missingPoints?: number;
}


export type PromoType = "CODE_PROMO" | "PANIER" | "ARTICLE" | "GROUP" | null;